import * as React from "react";
import { ResponsiveLayout } from "../components/layout/ResponsiveLayout";
import { SmallScreen } from "./SmallScreen";
import { LargeScreen } from "./LargeScreen";
export const Main = (): React.ReactElement => {
  return <ResponsiveLayout base={<SmallScreen />} lg={<LargeScreen />} />;
};
